export default {
    formFieldPrevencion: {
        numeroSolicitud: {
            name: 'numeroSolicitud',
            label: 'Número de solicitud *',
            requiredErrorMsg: 'Debe indicar el número de solicitud de la póliza emitida'
        },
        premium: {
            name: 'premium',
            label: 'Prima Emitida *',
            requiredErrorMsg: 'Debe indicar la prima emitida de la póliza emitida'
        },
        dni: {
            name: 'dni',
            label: 'DNI *',
            requiredErrorMsg: 'Debe especificar el DNI'
        },
        sexo: {
            name: 'sexo',
            label: 'Sexo *',
            requiredErrorMsg: 'Debe especificar el sexo'
        },
        cuit: {
            name: 'cuit',
            label: 'CUIT/CUIL *',
            requiredErrorMsg: 'Debe especificar el CUIT/CUIL'
        },
        cantidadCapitas: {
            name: 'cantidadCapitas',
            label: 'Cantidad de capitas *',
            requiredErrorMsg: 'Debe especificar la cantidad de capitas'
        },
        tipoAfiliacion: {
            name: 'tipoAfiliacion',
            label: 'Tipo de afiliación *',
            requiredErrorMsg: 'Debe especificar el tipo de afiliación'
        },
    }
};